import React, { FC } from 'react';
import { ImplementationGroup } from '@constants/entities/project';
import { Chip } from '@mui/material';
import { igBadgeColorMap } from '@theme/muiTheme';

type Props = {
  tier: ImplementationGroup;
};

const IgBadge: FC<Props> = ({ tier }) => (
  <Chip
    label={tier}
    size="small"
    variant="blue-outlined"
    sx={{
      pointerEvents: 'none',
      flexShrink: 0,
      ...igBadgeColorMap[tier],
    }}
  />
);

export default IgBadge;
